var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "observer",
    attrs: { tag: "form" },
    on: {
      submit: function ($event) {
        $event.preventDefault()
        return _vm.submit.apply(null, arguments)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ invalid }) {
          return [
            _c(
              "div",
              {
                staticClass: "modal-card",
                staticStyle: { "min-height": "750px" },
              },
              [
                _c("header", { staticClass: "modal-card-head" }, [
                  _c("p", { staticClass: "modal-card-title" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.editableUser ? "Edit" : "Create") +
                        " user "
                    ),
                  ]),
                ]),
                _c(
                  "section",
                  { staticClass: "modal-card-body" },
                  [
                    _c("ValidationProvider", {
                      attrs: { rules: "required", name: "Username", slim: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors, valid }) {
                              return [
                                _c(
                                  "b-field",
                                  {
                                    attrs: {
                                      label: "Username",
                                      type: {
                                        "is-danger": errors[0],
                                        "is-success": valid,
                                      },
                                    },
                                  },
                                  [
                                    _c("b-input", {
                                      attrs: {
                                        name: "username",
                                        placeholder: "endusername.city",
                                      },
                                      model: {
                                        value: _vm.newUser.username,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.newUser, "username", $$v)
                                        },
                                        expression: "newUser.username",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("ValidationProvider", {
                      attrs: { rules: "required", slim: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors, valid }) {
                              return [
                                _c(
                                  "b-field",
                                  {
                                    attrs: {
                                      label: "Display Name",
                                      type: {
                                        "is-danger": errors[0],
                                        "is-success": valid,
                                      },
                                    },
                                  },
                                  [
                                    _c("b-input", {
                                      attrs: {
                                        name: "displayName",
                                        type: "text",
                                        placeholder: "enduser name",
                                      },
                                      model: {
                                        value: _vm.newUser.displayName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.newUser,
                                            "displayName",
                                            $$v
                                          )
                                        },
                                        expression: "newUser.displayName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("ValidationProvider", {
                      attrs: { rules: "required", slim: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors }) {
                              return [
                                _c(
                                  "b-field",
                                  { attrs: { label: "Type" } },
                                  [
                                    _c(
                                      "b-radio-button",
                                      {
                                        attrs: {
                                          "native-value": "HUB",
                                          type: "is-primary",
                                          disabled: !_vm.isAdmin,
                                        },
                                        model: {
                                          value: _vm.newUser.type,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.newUser, "type", $$v)
                                          },
                                          expression: "newUser.type",
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "home" },
                                        }),
                                        _c("span", [_vm._v("HUB")]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-radio-button",
                                      {
                                        attrs: {
                                          "native-value": "CUSTOMER",
                                          type: "is-info",
                                          disabled: !_vm.isAdmin,
                                        },
                                        model: {
                                          value: _vm.newUser.type,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.newUser, "type", $$v)
                                          },
                                          expression: "newUser.type",
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "handshake" },
                                        }),
                                        _c("span", [_vm._v("CUSTOMER")]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-radio-button",
                                      {
                                        attrs: {
                                          "native-value": "END USER",
                                          type: "is-purple",
                                        },
                                        model: {
                                          value: _vm.newUser.type,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.newUser, "type", $$v)
                                          },
                                          expression: "newUser.type",
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "user" },
                                        }),
                                        _c("span", [_vm._v("END USER")]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-radio-button",
                                      {
                                        attrs: {
                                          "native-value": "PFT",
                                          type: "is-orange",
                                        },
                                        model: {
                                          value: _vm.newUser.type,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.newUser, "type", $$v)
                                          },
                                          expression: "newUser.type",
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "mobile-alt" },
                                        }),
                                        _c("span", [_vm._v("PFT")]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm.newUser.type !== "PFT"
                      ? _c(
                          "div",
                          [
                            _c("ValidationProvider", {
                              attrs: { rules: "required", slim: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors, valid }) {
                                      return [
                                        _c(
                                          "b-field",
                                          {
                                            attrs: {
                                              label: "Role",
                                              addons: false,
                                              type: {
                                                "is-danger": errors[0],
                                                "is-success": valid,
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "b-autocomplete",
                                              {
                                                attrs: {
                                                  data: _vm.filteredRoles,
                                                  "open-on-focus": "",
                                                  field: "name",
                                                  icon: "search",
                                                  clearable: "",
                                                },
                                                on: {
                                                  select: (option) =>
                                                    (_vm.newUser.role = option),
                                                },
                                                model: {
                                                  value: _vm.selectedRole,
                                                  callback: function ($$v) {
                                                    _vm.selectedRole = $$v
                                                  },
                                                  expression: "selectedRole",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "empty" },
                                                  [_vm._v(" No results found ")]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.newUser.type !== "PFT"
                      ? _c(
                          "div",
                          [
                            _c("ValidationProvider", {
                              attrs: { name: "Group", slim: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors, valid }) {
                                      return [
                                        _c(
                                          "b-field",
                                          {
                                            attrs: {
                                              label: "Group",
                                              addons: false,
                                              type: {
                                                "is-danger": errors[0],
                                                "is-success": valid,
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "b-autocomplete",
                                              {
                                                attrs: {
                                                  data: _vm.filteredGroups,
                                                  "open-on-focus": "",
                                                  field: "name",
                                                  icon: "search",
                                                  clearable: "",
                                                },
                                                on: {
                                                  select: (option) =>
                                                    (_vm.newUser.group =
                                                      option),
                                                },
                                                model: {
                                                  value: _vm.selectedGroup,
                                                  callback: function ($$v) {
                                                    _vm.selectedGroup = $$v
                                                  },
                                                  expression: "selectedGroup",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "empty" },
                                                  [_vm._v(" No results found ")]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("ValidationProvider", {
                      attrs: { rules: "required|email", slim: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors, valid }) {
                              return [
                                _c(
                                  "b-field",
                                  {
                                    attrs: {
                                      label: "Email",
                                      type: {
                                        "is-danger": errors[0],
                                        "is-success": valid,
                                      },
                                    },
                                  },
                                  [
                                    _c("b-input", {
                                      attrs: { name: "email", type: "email" },
                                      model: {
                                        value: _vm.newUser.email,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.newUser, "email", $$v)
                                        },
                                        expression: "newUser.email",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("ValidationProvider", {
                      attrs: { slim: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors, valid }) {
                              return [
                                _vm.editableUser
                                  ? _c(
                                      "b-field",
                                      {
                                        attrs: {
                                          label: "Password",
                                          type: {
                                            "is-danger": errors[0],
                                            "is-success": valid,
                                          },
                                        },
                                      },
                                      [
                                        _c("b-input", {
                                          attrs: {
                                            name: "password",
                                            type: "password",
                                            "password-reveal": "",
                                          },
                                          model: {
                                            value: _vm.newUser.password,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.newUser,
                                                "password",
                                                $$v
                                              )
                                            },
                                            expression: "newUser.password",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                ),
                _c("footer", { staticClass: "modal-card-foot" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-info is-fullwidth",
                      class: { "is-loading": _vm.isSubmitting },
                      attrs: { disabled: invalid, type: "submit" },
                    },
                    [_vm._v(" Submit ")]
                  ),
                ]),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }